export default "__VITE_ASSET__Dqto8nsK__"